import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';

export function AboutSummary() {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="bg-indigo-50 border border-indigo-100 rounded-xl p-8 text-center">
        <Heart className="w-8 h-8 text-indigo-600 mx-auto mb-4" />
        <h2 className="text-2xl font-bold text-gray-900 mb-3">¿Quiénes somos?</h2>
        <p className="text-gray-700 max-w-2xl mx-auto leading-relaxed mb-4">
          DonaApp es una plataforma creada por <strong>OVIEDOTECH S.A.S.</strong> que facilita la conexión entre 
          personas que necesitan productos y quienes quieren donarlos. Nuestro compromiso es la transparencia, 
          la verificación de campañas y la protección de datos de cada donante.
        </p>
        <Link
          to="/acerca-de"
          className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-700 transition-colors"
        >
          Conoce más sobre nosotros →
        </Link>
      </div>
    </section>
  );
}
